// extracted by mini-css-extract-plugin
export default {"wrap":"EventInfo_wrap__S3WN7"};